<template>
  <b-container>
    <b-row class="mt-2">
      <b-col md="1"></b-col>
      <b-col md="8">
        <b-form-group
          id="gsgblist"
          horizontal
          label-size="sm"
          label-cols="2"
          label="Board Name*"
          label-for="inpsgb"
        >
          <b-form-select
            id="inpsgb"
            :options="sgbList"
            value-field="SecurityBoardID"
            text-field="SecurityBoardName"
            required
            size="sm"
            :disabled="isBoardSelected"
            v-model="BoardID"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-button
          variant="primary"
          size="sm"
          @click="showModal"
          :disabled="!isBoardSelected"
        >Select Employer</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          show-empty
          head-variant="dark"
          stacked="md"
          bordered
          striped
          :items="appEmployers"
          :fields="fieldsEmployer"
          :current-page="currentPageEr"
          :per-page="perPageEr"
          :filter="filterEr"
          :sort-by.sync="sortByEr"
          :sort-desc.sync="sortDescEr"
          style="font-size:12px"
          @filtered="onFilteredEr"
        >
          <template slot="actions" slot-scope="row">
            <b-button variant="link" size="sm" @click.stop="editApplication(row.item, row.index, $event.target)" 
                        class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="Edit Application">
                        <i class="fa fa-pencil-alt" style="font-size:16px;color:blue"></i>
                    </b-button>                
            <!-- <b-button variant="link" size="sm" @click.stop="editApplication1(row.item, row.index, $event.target)" 
                        class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="Edit Application">
                        <i class="fa fa-pencil-alt" style="font-size:16px;color:blue"></i>
                    </b-button> -->
            <b-button
              variant="link"
              size="sm"
              @click.stop="viewEmployer(row.item, row.index, $event.target)"
              class="mr-1 pt-0 pb-0"
              v-b-tooltip.hover
              title="View Employer Details"
            >
              <i class="fa fa-eye" style="font-size:16px;color:green"></i>
            </b-button>
            <b-button
              size="sm"
              @click.stop="deleteEmployer(row.item, row.index, $event.target)"
              class="mr-1 pt-0 pb-0"
              variant="link"
              v-b-tooltip.hover
              title="Remove"
            >
              <i class="fa fa-trash" style="font-size:16px;color:red"></i>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button
          variant="success"
          size="small"
          class="float-right"
          @click="onApplicationSubmit"
        >Submit File</b-button>
        <b-button
          variant="danger"
          size="small"
          class="float-right mx-2"
          @click="onApplicationDelete"
          v-if="ExemptionApplicationID != '00000000-0000-0000-0000-000000000000'"
        >Delete Application</b-button>
        <b-button
          variant="secondary"
          size="small"
          class="float-right mx-2"
          @click="onApplicationCancel"
        >Cancel</b-button>
        <b-button
          variant="secondary"
          size="small"
          class="float-right mx-2"
          @click.prevent="editAgencyApplication"
        >Edit Aegncy Application</b-button>
        
      </b-col>
    </b-row>
    <b-modal ref="modalEmployer" size="lg" title="Add Employer and Guard Details" hide-footer>
      <b-row class="mb-3">
        <b-col md="7">
          <b-form-group
            id="grpEmployer"
            label="Select Employer <span style='color:red'>*</span>"
            horizontal
            label-cols="2"
            label-size="sm"
          >
            <b-form-select
              id="employerlist"
              :options="employers"
              v-model="selectedEmployer"
              size="sm"
              value-field="EmployerID"
              text-field="name_id"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row class="mb-2">
            <b-col md="8">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''" size="sm">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>

            <b-col>
              <b-button
                size="sm"
                class="float-right"
                variant="primary"
                @click="selectAll"
              >Select All</b-button>
            </b-col>
          </b-row>
          <b-table
            show-empty
            head-variant="dark"
            stacked="md"
            bordered
            striped
            :items="guards"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            style="font-size:12px"
            @filtered="onFiltered"
          >
            <template slot="actions" slot-scope="row">
              <b-button
                variant="link"
                size="sm"
                @click.stop="viewGuard(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                v-b-tooltip.hover
                title="View Guard Details"
              >
                <i class="fa fa-eye" style="font-size:16px;color:green"></i>
              </b-button>
              <b-button
                size="sm"
                @click.stop="selectGuard(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="link"
                v-b-tooltip.hover
                title="Select"
              >
                <i class="fas fa-arrow-circle-right" style="font-size:16px;color:blue"></i>
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col md="8" class="my-1">
              <b-pagination
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
                size="sm"
              />
            </b-col>
            <b-col md="4" class="my-1">
              <b-form-group
                horizontal
                label="Per page"
                class="mb-0"
                label-size="sm"
                :label-cols="6"
              >
                <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col style="font-size:0.875rem">
              <b>Total Guards:</b>
              {{totalRows}}
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row class="mb-2">
            <b-col md="8">
              <b-input-group>
                <b-form-input v-model="filter2" placeholder="Type to Search" size="sm" />
                <b-input-group-append>
                  <b-btn :disabled="!filter2" @click="filter2 = ''" size="sm">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>

            <b-col>
              <b-button
                size="sm"
                class="float-right"
                variant="warning"
                @click="removeAll"
              >Remove All</b-button>
            </b-col>

            <!-- <b-col md="6" >
                        <b-form-group horizontal label="Sort" class="mb-0" label-size="sm" label-cols="2">
                        <b-input-group>
                            <b-form-select v-model="sortBy2" :options="sortOptions2"  size="sm">
                            <option slot="first" :value="null">-- none --</option>
                            </b-form-select>
                            <b-input-group-append>
                            <b-form-select :disabled="!sortBy2" v-model="sortDesc2"  size="sm">
                                <option :value="false">Asc</option>
                                <option :value="true">Desc</option>
                            </b-form-select>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
            </b-col>-->
          </b-row>
          <b-table
            show-empty
            head-variant="dark"
            stacked="md"
            bordered
            striped
            :items="selectedGuards"
            :fields="fields"
            :current-page="currentPage2"
            :per-page="perPage2"
            :filter="filter2"
            :sort-by.sync="sortBy2"
            :sort-desc.sync="sortDesc2"
            style="font-size:12px"
            @filtered="onFiltered2"
          >
            <template slot="actions" slot-scope="row">
              <b-button
                variant="link"
                size="sm"
                @click.stop="viewGuard(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                v-b-tooltip.hover
                title="View Guard Details"
              >
                <i class="fa fa-eye" style="font-size:16px;color:green"></i>
              </b-button>
              <b-button
                size="sm"
                @click.stop="deleteGuard(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="link"
                v-b-tooltip.hover
                title="Remove"
              >
                <i class="fa fa-trash" style="font-size:16px;color:red"></i>
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col md="8" class="my-1">
              <b-pagination
                :total-rows="totalRows2"
                :per-page="perPage2"
                v-model="currentPage2"
                class="my-0"
                size="sm"
              />
            </b-col>
            <b-col md="4" class="my-1">
              <b-form-group
                horizontal
                label="Per page"
                class="mb-0"
                label-size="sm"
                :label-cols="6"
              >
                <b-form-select :options="pageOptions2" v-model="perPage2" size="sm" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col style="font-size:0.875rem">
              <b>Total Guards:</b>
              {{totalRows2}}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            variant="success"
            size="small"
            class="float-right mx-2"
            @click="onSubmit"
          >Add Employer</b-button>
          <b-button variant="success" size="small" class="float-right mx-2" @click="onCancel">Cancel</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <!--
      ******************************************************************************************
      Popup of Guards Profile
      ******************************************************************************************
    -->
    <b-modal id="modalViewGuard" title="View Guard Details" size="lg" cancel-disabled>
      <GuardProfile :GuardID="selectedId"></GuardProfile>
    </b-modal>
    <b-modal id="modalEditGuard" title="Guard Details" size="lg" cancel-disabled>
      <ExemptionApplicationGuardMap v-if="applicationId" :ExemptionApplicationId="applicationId" @clicked="show3()"></ExemptionApplicationGuardMap>
    </b-modal>
    <!--
      ******************************************************************************************
      Popup to Confirm Application Submission - not used
      ******************************************************************************************
    -->

    <b-modal id="modalConfirmSubmit" title="Confirm Submit" size="sm">
      <p>You will not be able to make any changes in the application. Do you want to Submit the application?</p>
      <div slot="modal-footer">
        <b-button
          variant="success"
          @click="onSubmitConfirm"
          style="margin-left:5px"
        >Submit Application</b-button>
        <b-button variant="secondary" @click="onCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
    <!--
      ******************************************************************************************
      ******************************************************************************************
      Popup of Guards for Selected Employers
      ******************************************************************************************
      ******************************************************************************************
    -->
    <b-modal ref="mdlGuardList" hide-footer title="Guards List">
      <b-table
        show-empty
        head-variant="dark"
        stacked="md"
        bordered
        striped
        :items="selectedGuards"
        :fields="fields"
        :current-page="currentPage2"
        :per-page="perPage2"
        :filter="filter2"
        :sort-by.sync="sortBy2"
        :sort-desc.sync="sortDesc2"
        style="font-size:12px"
        @filtered="onFiltered2"
      >
        <template slot="actions" slot-scope="row">
          <!-- <b-button
            variant="link"
            size="sm"
            @click.stop="viewGuard(row.item, row.index, $event.target)"
            class="mr-1 pt-0 pb-0"
            v-b-tooltip.hover
            title="View Guard Details"
          >
            <i class="fa fa-eye" style="font-size:16px;color:green"></i>
          </b-button>-->
          <b-button
            size="sm"
            @click.stop="removeStgGuard(row.item, row.index, $event.target)"
            class="mr-1 pt-0 pb-0"
            variant="link"
            v-b-tooltip.hover
            title="Remove"
          >
            <i class="fa fa-trash" style="font-size:16px;color:red"></i>
          </b-button>
        </template>
      </b-table>
      <b-row>
        <b-col md="8" class="my-1">
          <b-pagination
            :total-rows="totalRows2"
            :per-page="perPage2"
            v-model="currentPage2"
            class="my-0"
            size="sm"
          />
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
            <b-form-select :options="pageOptions2" v-model="perPage2" size="sm" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col style="font-size:0.875rem">
          <b>Total Guards:</b>
          {{totalRows2}}
        </b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import RegisterOnBehalf from "@/components/OtherRegistrations/RegisterOnbehalf";
import GuardProfile from "@/components/OtherRegistrations/GuardProfile";
import * as _ from "lodash";
import ExemptionApplicationGuardMap from "@/components/AgencyExemption/ExemptionApplicationGuardMap";

export default {
  components: { RegisterOnBehalf, GuardProfile,ExemptionApplicationGuardMap },
  computed: {
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      //console.log(x);
      return x;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    sortOptions2() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  watch: {
    BoardID(newValue, oldValue) {
      if (newValue != null && newValue != "") {
        this.isBoardSelected = true;
      } else {
        this.isBoardSelected = false;
      }
    }
  },
  data() {
    return {
      isBoardSelected: false,
      name: "",
      sgbList: [],
      employers: [],
      appEmployers: [],
      selectedEmployer: "",
      guards: [],
      BoardID: null,
      selectedGuards: [],
      fields: [
        { key: "GuardName", label: "Guard Name", sortable: true },
        { key: "RegistrationNumber", label: "Registration No", sortable: true },
        { key: "actions", label: "-" }
      ],
      fieldsEmployer: [
        {
          key: "EntityName",
          label: "Selected Employer Name",
          sortable: true
        },
        { key: "RegistrationNumber", label: "Registration No", sortable: true },
        { key: "GuardCount", label: "Total Guards" },
        { key: "actions", label: "-" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPageEr: 1,
      perPageEr: 5,
      totalRowsEr: 0,
      pageOptionsEr: [5, 10, 20, 50, 100],
      sortByEr: null,
      sortDescEr: false,
      filterEr: null,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      currentPage2: 1,
      perPage2: 10,
      totalRows2: 0,
      pageOptions2: [5, 10, 15, 20, 50],
      sortBy2: null,
      sortDesc2: false,
      filter2: null,
      selectedId: "00000000-0000-0000-0000-000000000000",
      ExemptionApplicationID: "00000000-0000-0000-0000-000000000000",
      applicationId:'',
      ApplicationDetails:'',
    };
  },
  methods: {
    editAgencyApplication(item,index,target){
      // alert(item.ExemptionApplicationID)
        this.$router.push({name: 'EditStgAgencyApplication',params:{"applicationId": this.ExemptionApplicationID,'ApplicationDetails':this.ApplicationDetails}});
        /*Don't use path in the push when usign props*/
    },
    editApplication(item,index,target){
      // alert(item.ExemptionApplicationID)
        this.$router.push({name: 'EditStgApplication',params:{"applicationId": item.ExemptionApplicationID}});
        /*Don't use path in the push when usign props*/
    },
    editApplication1(item,index,target)
    { 
      this.applicationId=item.ExemptionApplicationID;
      this.$root.$emit("bv::show::modal", "modalEditGuard");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered2(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows2 = filteredItems.length;
      this.currentPage2 = 1;
    },
    onFilteredEr(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsEr = filteredItems.length;
      this.currentPageEr = 1;
    },
    selectAll() {
      this.selectedGuards = _.concat(this.selectedGuards, this.guards);
      this.guards = [];
    },
    removeAll() {
      this.guards = _.concat(this.guards, this.selectedGuards);
      this.selectedGuards = [];
    },
    viewGuard(item, index, button) {
      this.selectedId = item.GuardID;
      this.$root.$emit("bv::show::modal", "modalViewGuard");
    },
    showModal() {
      this.selectedGuards = [];
      this.totalRows2 = 0;
      this.$refs["modalEmployer"].show();
    },
    //Edit Member
    selectGuard(item, index, button) {
      this.selectedGuards.push(item);
      this.guards = _.remove(this.guards, function(n) {
        return n.GuardID != item.GuardID;
      });
      this.totalRows = this.guards.length;
      this.totalRows2 = this.selectedGuards.length;
    },

    //Delte Mapping post confirmation
    deleteGuard(item, index, button) {
      this.guards.push(item);
      this.selectedGuards = _.remove(this.selectedGuards, function(n) {
        return n.GuardID != item.GuardID;
      });
      this.totalRows = this.guards.length;
      this.totalRows2 = this.selectedGuards.length;
    },

    onApplicationSubmit(evt) {
      evt.preventDefault();
      //this.$root.$emit("bv::show::modal", "modalConfirmSubmit");
      var t = this;
      this.$dialog
        .confirm(
          "You will not be able to make any changes in the application. Do you want to Submit the application?",
          { okText: "Submit Application", cancelText: "Close" }
        )
        .then(function(dialog) {
          return t.onSubmitConfirm();
        })
        .catch(function() {});
    },

    onApplicationCancel(evt) {
      evt.preventDefault();
      this.$router.push("/dashboard");
    },

    onApplicationDelete(evt) {
      evt.preventDefault();
      var id = this.ExemptionApplicationID;
      this.$dialog
        .confirm("Please confirm to continue")
        .then(function(dialog) {
          return apis.RemoveStageExemptionApplication(id);
        })
        .then(response => {
          if (response.status == 200) {
            this.$dialog.alert("Application Removed Successfully");
          }
        })
        .catch(function() {});
    },

    modalInfo() {
      return;
    },

    onCancel() {
      this.$root.$emit("bv::hide::modal", "modalConfirmSubmit");
    },
    viewEmployer(item, index, target) {
      let Promise = apis.ReadStgGuardsByEmployerID(item.ExemptionEmployerID);

      Promise.then(response => {
        if (response.status == 200) {
          this.selectedGuards = response.body;
          this.totalRows2 = this.selectedGuards.length;
        }
      }).catch(err => {
        this.$dialog.alert("Error in Loading Data");
      });

      this.$refs["mdlGuardList"].show();
    },

    removeStgGuard(item, index, target) {
      this.$dialog
        .confirm("Please confirm to continue")
        .then(function(dialog) {
          return apis.RemoveStageExemptionGuard(item.StgExemptionGuardID);
        })
        .then(response => {
          if (response.status == 200) {
            this.$dialog.alert("Guard Removed Successfully");
            this.selectedGuards = _.remove(this.selectedGuards, function(n) {
              return n.StgExemptionGuardID != item.StgExemptionGuardID;
            });
            this.totalRows2 = this.selectedGuards.length;
          }
        })
        .catch(function() {});
    },

    deleteEmployer(item, index, target) {
      this.$dialog
        .confirm("Please confirm to continue")
        .then(function(dialog) {
          return apis.RemoveStageExemptionEmployer(item.ExemptionEmployerID);
        })
        .then(response => {
          if (response.status == 200) {
            this.$dialog.alert("Employer Removed Successfully");
            this.getStgEmployerList();
            this.getAgencyMapping(11);
            this.getAgencyMapping(12);
          }
        })
        .catch(function() {});
    },
    
    onSubmitConfirm() {
      //this.$root.$emit("bv::hide::modal", "modalConfirmSubmit");
      // alert(this.ExemptionApplicationID);
      // return;
      let userinfo = this.$store.getters.loggedUser;
      let promise = apis.submitExemptApplication(
        this.ExemptionApplicationID,
        userinfo.UserId
      );

      promise
        .then(response => {
          if (response.status == 200) {
            this.appEmployers = [];
            this.BoardID = null;
            this.$dialog.alert("Application Saved Successfully");
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      //this.$root.$emit("bv::hide::modal", "modalConfirmSubmit");
    },
    onSubmit(evt) {
      evt.preventDefault();

      //Validate the form values
      if (this.selectedEmployer == null || this.selectedEmployer == "") {
        this.showDismissibleAlert = true;
        this.alertText = "Please Select Employer";
        return;
      }

      if (this.BoardID == null || this.BoardID == "") {
        this.showDismissibleAlert = true;
        this.alertText = "Please Select Board";
        return;
      }
      if (this.totalRows2 == 0) {
        this.showDismissibleAlert = true;
        this.alertText = "Please Select Guards";
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var guardList = [];
      let ttl = this.selectedGuards.length;

      for (let r = 0; r < ttl; r++) {
        guardList.push({ GuardRegistraionID: this.selectedGuards[r].GuardID });
      }

      let form = {
        ExemptionApplicationID: this.ExemptionApplicationID,
        AgencyID: userinfo.UserId,
        BoardID: this.BoardID,
        ExemptionApplicationUser: userinfo.UserId,
        EmpList: [
          {
            ExemptionEmployerID: "00000000-0000-0000-0000-000000000000",
            ExemptionApplicationID: this.ExemptionApplicationID,
            EmployerRegistraionID: this.selectedEmployer,
            CreatedUser: userinfo.UserId,
            GuardList: guardList
          }
        ]
      };

      let promise = apis.AddExemptionEmployer(form);
      promise
        .then(response => {
          if (response.status == 200) {
            this.ExemptionApplicationID = response.body[0].ApplicationID;
            this.getStgEmployerList();
            this.$dialog.alert("Application Submitted Successully");
            this.$refs["modalEmployer"].hide();
          } else {
            this.alertText = "response.body";
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(error => {
          this.alertText = "ERROR: " + error.message;
          this.variant = "danger";
          this.showDismissibleAlert = true;
        });
    },

    getSGBList() {
      this.sgbList = this.$store.getters.getSGBList;
      if (this.sgbList.length == 0) {
        let promise = apis.readSGBoardName();

        promise
          .then(response => {
            if (response.status == 200) {
              let rspns = response.body;
              this.sgbList = response.body;
              this.$store.dispatch("setSGBList", rspns);
            } else {
              this.alertText = "Unable to Load Board List, " + response.body;

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
            this.isLoading = false;
          })
          .catch(err => {
            this.alertText = "Unable to Load Board List, " + err.body;
            this.showDismissibleAlert = true;
            this.variant = "danger";
            this.isLoading = false;
          });
      }
    },
    getAgencyMapping(RegType) {
      var userinfo = this.$store.getters.loggedUser;
      let promise;
      if (RegType == 11) {
        promise = apis.getAgencyEmployerMapping(userinfo.UserId);
      } else {
        promise = apis.getAgencyGuardMapping(userinfo.UserId);
      }

      promise
        .then(response => {
          if (response.status == 200) {
            if (RegType == 11) {
              this.employers = _.remove(response.body, function(n) {
                return n.RegistrationNumber > 0;
              });
              this.employers = this.employers.map(function(el) {
                var o = Object.assign({}, el);
                o.name_id = o.EmployerName + " (" + o.RegistrationNumber + ")";
                return o;
              });
              //this.employers = response.body;
            } else {
              this.guards = _.remove(response.body, function(n) {
                return n.RegistrationNumber > 0;
              });
              //this.guards = response.body;
              this.totalRows = this.guards.length;
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getStgEmployerList() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.GetExtempionEmployerListStg(userinfo.UserId);
      promise
        .then(response => {
          if (response.status == 200) {
            this.appEmployers = response.body;
            this.BoardID = response.body[0].BoardID;
            this.ExemptionApplicationID =
              response.body[0].ExemptionApplicationID;
            this.ApplicationDetails=response.body[0].ApplicationDetails;

          }
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getSGBList();
    this.getStgEmployerList();
    this.getAgencyMapping(11);
    this.getAgencyMapping(12);
  }
};
</script>

<style>
.modal-lg {
  max-width: 95%;
}
</style>





// WEBPACK FOOTER //
// src/components/ApplyForExemption/ApplyForExemption.vue